import React, { useContext, useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import toast, { Toaster } from "react-hot-toast";
import Backbutton from "../../Components/Header/Backbutton";
import { message, Switch } from "antd";
import { PulseLoader } from "react-spinners";
import { AppContext } from "../../Context/AppContext";
import { useNavigate } from "react-router-dom";

function AddAdmin() {
  const navigate = useNavigate();
  const { adminsLoading, addNewAdmin, fetchAdmins } = useContext(AppContext);
  const [adminDetails, setAdminDetails] = useState({
    name: "",
    email: "",
    role: "",
    notifications: false,
    password: "",
    confirm_password: "",
  });
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "password" || name === "confirm_password") {
      const trimmedValue = value.replace(/\s+/g, "");
      setAdminDetails((prevDetails) => ({
        ...prevDetails,
        [name]: trimmedValue,
      }));
      return;
    }

    setAdminDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleEmptyFields = () => {
    if (
      !adminDetails.name ||
      adminDetails.name.trim() === "" ||
      adminDetails.name.length === 0 ||
      !adminDetails.email ||
      adminDetails.email.trim() === "" ||
      adminDetails.email.length === 0 ||
      !adminDetails.role ||
      !adminDetails.password ||
      adminDetails.password.trim() === "" ||
      adminDetails.password.length === 0 ||
      !adminDetails.confirm_password ||
      adminDetails.confirm_password.trim() === "" ||
      adminDetails.confirm_password.length === 0
    ) {
      setError(true);
      return true;
    }
    setError(false);
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isEmpty = handleEmptyFields();
    if (isEmpty) {
      toast.error("Please fill all the fields.");
      return;
    }

    const payload = {
      name: adminDetails.name,
      email: adminDetails.email,
      role: adminDetails.role,
      notifications: adminDetails.notifications,
      password: adminDetails.password,
    };

    await addNewAdmin(payload, {
      onSuccess: async (res) => {
        toast.success("New Admin profile has been created!");
        await fetchAdmins();
        navigate("/admins");
      },
      onFailed: (err) => {
        const errMsg = err?.data ?? "Profile not created, Please try again!";
        toast.error(errMsg);
        console.log("Admin create error", err);
      },
    });
  };

  useEffect(() => {
    if (adminDetails.role === "superadmin") {
      setAdminDetails((prevDetails) => ({
        ...prevDetails,
        notifications: true,
      }));
      message.open({
        content: (
          <div style={{ color: "#ff4d4f" }}>
            👉🏼 Super Admins receive notifications by default and cannot modify
            this setting.
          </div>
        ),
      });
      return;
    }
    setAdminDetails((prevDetails) => ({
      ...prevDetails,
      notifications: false,
    }));
  }, [adminDetails.role]);

  return (
    <>
      <Header />
      <div className="container-fluid background">
        <div className="mains">
          <Toaster position="top-center" />
          <div className="edit-title data mb-3">
            <div className="start-edit">
              <Backbutton />
            </div>
            <div className="center-edit text-center">
              <h4 className="dash-head text-center">Add New Admin Profile</h4>
            </div>
          </div>
          <div className="section add-category">
            <div className="card review_card add_business_card">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Fullname <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        id=""
                        className="form-control"
                        placeholder="Enter Admin Name"
                        onChange={handleChange}
                        value={adminDetails.name}
                      />
                      {error && adminDetails?.name.length === 0 && (
                        <span className="text-danger">Name is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        id=""
                        className="form-control"
                        placeholder="Enter Admin Email Address"
                        onChange={handleChange}
                        value={adminDetails.email}
                        required
                      />
                      {error && adminDetails.email.length === 0 && (
                        <span className="text-danger">Email is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Role <span className="text-danger">*</span>
                      </label>
                      <select
                        name="role"
                        id=""
                        className="form-select"
                        onChange={handleChange}
                      >
                        <option value="" selected disabled>
                          Select Role
                        </option>
                        <option value="superadmin">Super Admin</option>
                        <option value="admin">Admin</option>
                      </select>
                      {error && adminDetails.role.length === 0 && (
                        <span className="text-danger">Role is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Notifications
                      </label>
                      <br />
                      <Switch
                        checked={adminDetails.notifications}
                        size="large"
                        onChange={(e) => {
                          setAdminDetails((prevDetails) => ({
                            ...prevDetails,
                            notifications: e,
                          }));
                        }}
                        disabled={
                          adminsLoading || adminDetails.role === "superadmin"
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="password"
                        id=""
                        className="form-control"
                        placeholder="Enter Admin Password"
                        onChange={handleChange}
                        value={adminDetails.password}
                        required
                      />
                      {adminDetails.password.length > 0 &&
                        adminDetails.password.length < 6 && (
                          <span className="text-danger">
                            Min Password length is 6
                          </span>
                        )}
                      {error && adminDetails.password.length === 0 && (
                        <span className="text-danger">
                          Password is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        name="confirm_password"
                        id=""
                        className="form-control"
                        placeholder="Confirm Admin Password"
                        onChange={handleChange}
                        value={adminDetails.confirm_password}
                      />
                      {error && adminDetails.confirm_password.length === 0 && (
                        <span className="text-danger">
                          Confirm Password is required
                        </span>
                      )}
                      {adminDetails.password !==
                        adminDetails.confirm_password && (
                        <span className="text-danger">
                          Passwords do not match
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="text-center mt-3">
                  <button
                    type="submit"
                    className="btn btn-danger"
                    disabled={adminsLoading}
                  >
                    {adminsLoading ? (
                      <PulseLoader color="#fff" size={10} />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAdmin;
